import cn from "classnames";

interface SkipToMainBtnProps {
  text: string;
  classNames?: string;
  isConsolidatedNavigation?: boolean;
}

const SkipToMainBtn = ({
  text,
  classNames,
  isConsolidatedNavigation = false,
}: SkipToMainBtnProps) => {
  const onClickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    const main = document.getElementById("main-content");
    if (main) {
      main.tabIndex = -1;
      main.style.scrollMarginTop = "0px";
      main.focus();
      main.tabIndex = 0;
    }
  };

  return (
    <a
      href="#main-content"
      className={cn(
        "text-swdc-blue-500 pointer-events-none w-0 cursor-default rounded border-2 border-[#005fcc] bg-white font-bold tracking-normal whitespace-nowrap opacity-0 outline outline-white focus-visible:w-auto focus-visible:cursor-pointer focus-visible:opacity-100",
        isConsolidatedNavigation
          ? "text-link-xs absolute px-1 underline"
          : "font-red-hat-display text-sm",
        classNames,
      )}
      onClick={onClickHandler}
    >
      {text}
    </a>
  );
};

export default SkipToMainBtn;
